const DISPLAY_NAME = 'Product Spotlight';

/**
 * Returns product-count errors for a spotlight. Aisle save uses this without the link-text rules.
 *
 * @param {Object} slice - Product spotlight data
 * @param {number} position - 1-based position used in error messages
 * @returns {string[]} Validation messages
 */
export function getProductSpotlightItemCountErrors(slice, position) {
    const errors = [];
    const productCount = slice.items?.length ?? 0;

    if (productCount < 1) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires a product.`);
    }

    if (productCount > 2) {
        errors.push(`${DISPLAY_NAME} (position ${position}) allows at most 2 products.`);
    }

    return errors;
}

/**
 * Validates a product spotlight slice for storefront publish.
 *
 * @param {Object} slice - Product spotlight data
 * @param {number} position - 1-based position used in error messages
 * @returns {string[]} Validation messages
 */
export function validateProductSpotlight(slice, position) {
    const errors = getProductSpotlightItemCountErrors(slice, position);

    if (slice.linkText && !slice.linkUrl) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires a link URL if link text is provided.`);
    }

    if (!slice.linkText && slice.linkUrl) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires link text if a link URL is provided.`);
    }

    return errors;
}
